import * as dataService from '../../Utils/DataService';
import { getFlowValue } from './akoya-session';

export async function GetAkoyaRequestStatus(code, isReauthorized) {
  let apiurl = getFlowValue('apiurl');
  let key = getFlowValue('key');
  let body = {};
  body['Token'] = code;
  body['IsReauthenticate'] = isReauthorized;
  let postProperties = {
    BaseUrl: `${apiurl}/akoyarequest/getstatus`,
    Method: 'POST',
    SuccessMessage: 'Request Successful',
    FailureMessage: 'Request Failed',
    SuppressMessageOverride: false,
    ShowMessage: '',
    CallBody: body,
    HeaderVals: {
      'Content-Type': 'application/json',
      'Ocp-Apim-Subscription-Key': key,
      //'cookie-key':cookie,
    },
  };
  return await fetch(postProperties.BaseUrl, {
    method: 'POST',
    headers: postProperties.HeaderVals,
    body: JSON.stringify(body),
  });
}

export async function SaveAkoyaRequestAuth(authCode, code) {
  let body = {};
  body['RequestToken'] = code;
  body['authCode'] = authCode;
  let apiurl = getFlowValue('apiurl');
  let key = getFlowValue('key');
  let postProperties = {
    BaseUrl: `${apiurl}/akoyarequest/saveauth`,
    Method: 'POST',
    SuccessMessage: 'Request Successful',
    FailureMessage: 'Request Failed',
    SuppressMessageOverride: false,
    ShowMessage: '',
    CallBody: body,
    HeaderVals: {
      'Content-Type': 'application/json',
      'Ocp-Apim-Subscription-Key': key,
    },
  };
  return await fetch(postProperties.BaseUrl, {
    method: 'POST',
    headers: postProperties.HeaderVals,
    body: JSON.stringify(body),
  });
}
